import React, { useContext, useState } from 'react';
import './Employment.css';
import { useTranslation } from 'react-i18next';
import DataContext from '../../context/Datacontext';
import useWindowSize from '../../hooks/useWindowSize';
import Empolyment from '../../images/Employment.svg';
import EmpolymentAR from '../../images/EmploymentAR.svg';

import axios from '../../api/DataTrans';
// import io from 'socket.io-client';
const Employment = () => {
    // const socket = io.connect("https://way-go.vercel.app/");
    const {lang} = useContext(DataContext);
    const [t] = useTranslation("global");
    const {width} = useWindowSize();
    const [name,setName] = useState('');
    const [phone,setPhone] = useState('');
    const [address,setAddress] = useState('');
    const [skills,setSkills] = useState('');
    const sendEmploymentOrder = async (e) => {
        e.preventDefault();
        // socket.emit("send_message",
        //     {
        //         'name':name,
        //         'phone':phone,
        //         "address":address,
        //         "homework":skills
        //     },
        // );
        try{
            const response = await axios.post('/web/sendEmployeRequest',{
                'name':name,
                'phone':phone,
                "address":address,
                "homework":skills
              },
              {
                headers:{
                  'Content-Type' : 'application/json'
                },
              },
              );
              alert(lang?'تم ارسال الرسالة بنجاح':'the request is sent')
              setName('');
              setPhone('');
              setAddress('');
              setSkills('');
              console.log(response);
        }
        catch(err){
            console.log(err);
        }
    }
  return (
    <div className='epmployment_main' style={{
            // justifyContent:lang ? width > 600 ? 'flex-end' : 'center' : width > 600 ? 'flex-end' :  'center',
            flexDirection:lang ? width > 1000 ? 'row' : 'column' : width > 1000 ? 'row-reverse' :  'column',
            paddingTop:width < 1000 ? "100px":'0px',paddingBottom:width < 1000 ? "100px":'0px'
            }}>
        <div className='epmployment_container_box'
             style={{
                // marginLeft:!lang && width > 1000 ? '50px' : '0px',marginRight:lang && width > 1000 ? '70px' : '0px',
                    //  marginTop:width<1000 ?'50px':'0px',
                     flexDirection:width<425?'column':'row',
                     marginLeft:width > 1000 && !lang?'0px':'50px',marginRight:width > 1000 && lang?'0px':'50px',
             }}
        >
            <div className='epmployment_box_1'>
                {!lang && <img src={Empolyment} alt='' style={{width:width<=1000 ? "80%" : "100%"}}/>}
                {lang && <img src={EmpolymentAR} alt='' style={{width:width<=1000 ? "80%" : "100%"}}/>}
            </div>
        </div>
        <div className='epmployment_container' 
             style={{marginLeft:width > 600 && !lang?'100px':'0px',marginRight:width > 600 && lang?'100px':'0px',
                     justifyContent:lang?'flex-end':'flex-start',marginTop:width<1000 ? '45px':'0px'}}>
            <div className='epmployment_h1' style={{alignItems:lang?'flex-end':'flex-start'}}>
                <p className='epmployment_para'>{t("employment.join")}</p>
            </div>
            <div className='epmployment_h2' style={{alignItems:lang?'flex-end':'flex-start',marginTop:'10px',marginBottom:'10px'}}>
                <p className='epmployment_para'>{t("employment.send_your")}</p>
            </div>
            <form onSubmit={sendEmploymentOrder}>
                <div className='epmployment_h2' style={{alignItems:lang?'flex-end':'flex-start'}}>
                    <p className='epmployment_para'>{t("employment.name")}</p>
                    <input className='employInput' type='text' required onChange={(e) => setName(e.target.value)} value={name}
                        style={{textAlign:lang?'right':'left',paddingLeft:!lang?'5px':'0px',paddingRight:lang ? '5px':'0px'}}
                    />
                </div>
                <div className='epmployment_h2' style={{alignItems:lang?'flex-end':'flex-start'}}>
                    <p className='epmployment_para'>{t("employment.phone")}</p>
                    <input className='employInput' maxLength={10} minLength={10} type='text' required onChange={(e) => setPhone(e.target.value)} value={phone}
                        style={{textAlign:lang?'right':'left',paddingLeft:!lang?'5px':'0px',paddingRight:lang ? '5px':'0px'}}
                    />
                </div>
                <div className='epmployment_h2' style={{alignItems:lang?'flex-end':'flex-start'}}>
                    <p className='epmployment_para'>{t("employment.address")}</p>
                    <input className='employInput' type='text' required onChange={(e) => setAddress(e.target.value)} value={address} 
                        style={{textAlign:lang?'right':'left',paddingLeft:!lang?'5px':'0px',paddingRight:lang ? '5px':'0px'}}
                    />
                </div>
                <div className='epmployment_h2' style={{alignItems:lang?'flex-end':'flex-start'}}>
                    <p className='epmployment_para'>{t("employment.skills")}</p>
                    <textarea className='employInput' type='text' required onChange={(e) => setSkills(e.target.value)} value={skills}
                        style={{textAlign:lang?'right':'left',paddingLeft:!lang?'5px':'0px',paddingRight:lang ? '5px':'0px',resize:'vertical',height:'80px'}}
                    />
                </div>
                <div className='epmployment_h3' style={{justifyContent:lang?'flex-end':'flex-start'}}>
                    <button type='submit' className='epmployment_sign'>{t("employment.send")}</button>
                </div>
            </form>
        </div>
    </div>
  )
}

export default Employment